import { agreementRelationshipManager, type IAgreementRelationship } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { RETRIEVE_RELATIONSHIP_TYPE } from './mutations';
import { type RelationshipData } from './types';

export const DISPLAY_TYPE_OPTIONS = 'displayTypeOptions';

export const actions: ActionTree<IAgreementRelationship, unknown> = {
    async [DISPLAY_TYPE_OPTIONS](context) {
        const responseData: RelationshipData = await agreementRelationshipManager.importAgreementRelationshipTypes();
        context.commit(RETRIEVE_RELATIONSHIP_TYPE, { responseData });
    }
};
